import { image_importer } from "../../../helper/helper_functions";

import { useState, useEffect } from "react";
import { JigsawPuzzle } from "react-jigsaw-puzzle";
import { useUserContext } from '../../../hooks/useUserContext';
import { useTranslation } from 'react-i18next';
import "react-jigsaw-puzzle/lib/jigsaw-puzzle.css";
import "./Loyalitaetskonflikt.css";

export default function Loyalitaetskonflikt({oldAndNewScore}) {
  const { t } = useTranslation();
  const { games, updateGames, calculateScore, score, language } = useUserContext();

  //import images
  const img = image_importer(require.context('../../../assets/games/schutzrechte/loyalitaet', false, /\.(png|jpe?g|svg)$/));
  var src;
  if (language.includes("de")) {
    src = img["loyalitaetskonflikt_de.png"];
  } else if (language.includes("fr")) {
    src = img["loyalitaetskonflikt_fr.png"];
  } else if (language.includes("it")) {
    src = img["loyalitaetskonflikt_it.png"];
  } else {
    src = img["loyalitaetskonflikt_de.png"];
  }


  //variables for updating score and state
  const puzzle = games.loyalitaetskonflikt;
  const max_points = games.loyalitaetskonflikt.points_max;

  //Code for setting Title
  const [text, setText] = useState(t('loyalitaetskonflikt.start_text'));

  //when puzzle is finished
  const set = () => {
      setText(t('loyalitaetskonflikt.finish_text'));
      setRunning(false);
      //console.log(time);
      const puzzle_new = { ...puzzle, state: 'done', points_achieved: max_points };
      const games_new = { ...games, loyalitaetskonflikt: puzzle_new };
      updateGames(games_new);
      const current_game = "loyalitaetskonflikt";
      let total_score = calculateScore(current_game);
      total_score += max_points;
      const oldScore = score;
      const newScore = total_score;
      oldAndNewScore(oldScore, newScore);
      //updateScore(total_score);
      document.getElementById("msg").style.visibility = "visible";
  };

  //Code for Timer
  const [time, setTime] = useState(0);
  const [running, setRunning] = useState(true);

  useEffect(() => {
    let interval;
    if (running) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime + 10);
      }, 10);
    } else if (!running) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [running]);

  return (
    <div className="puzzle_loyal">
      <h2>{text}</h2>
      <p>{t('loyalitaetskonflikt.explanation')}</p>
      {/*<div className="numbers">
        <span>{("0" + Math.floor((time / 60000) % 60)).slice(-2)}:</span>
        <span>{("0" + Math.floor((time / 1000) % 60)).slice(-2)}:</span>
        <span>{("0" + ((time / 10) % 100)).slice(-2)}</span>
      </div>*/}
      <JigsawPuzzle
        imageSrc={src}
        rows={3}
        columns={2}
        onSolved={set}
        class-Name="jigsaw-puzzle"
      />
      <div className="msg_success" id="msg">
        <p>{t('loyalitaetskonflikt.msg_success')}</p>
      </div>
    </div>
  )
}
